import { Stack, LinearProgress, Container } from "@mui/material";
import LoadingMessage from "./LoadingMessage";
import JunctionCoreConsignEdgeLogo from "../assets/JunctionCoreConsignEdgeLogo";

export const LoadingWithBrand = ({ message = "Loading! Please Wait..." }) => {
  return (
    <Stack
      sx={{
        width: "100%",
        paddingBottom: "10%",
        justifyContent: "center",
        alignItems: "center",
        flex: "1 1 auto",
        display: "flex",
        flexDirection: "column",
      }}
      color="primary"
      spacing={2}
    >
      <LinearProgress sx={{ width: "100%", height: "1.5px" }} />
      <Container
        maxWidth="sm"
        sx={{
          flex: "1 1 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack sx={{ display: "flex" }}>
          <JunctionCoreConsignEdgeLogo />
          <LoadingMessage message={message} />
        </Stack>
      </Container>
    </Stack>
  );
};

export default LoadingWithBrand;
